import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  CorreoEntidadDTO,
  MetricaEntidadDto,
  RespuestaCorreoDTO,
} from '../dto/metrica-entidad/metrica-entidad.dto';

@Injectable({
  providedIn: 'root',
})
export class MetricaEntidadService {
  private apiUrl = environment.apiUrl; // Base API URL

  constructor(private http: HttpClient) {}

  /*  obtenerMetricasConEntidad(): Observable<MetricaEntidadDto[]> {
    // Convert params object to HttpParams
    const baseUrl = '/metrica-entidad/metrica-con-entidad'; // Specific endpoint
    return this.http.get<MetricaEntidadDto[]>(`${this.apiUrl}${baseUrl}`);
  }*/
  obtenerMetricasConEntidad(
    idEntidad?: number
  ): Observable<MetricaEntidadDto[]> {
    const baseUrl = '/metrica-entidad/metrica-con-entidad';
    let params = new HttpParams();
    if (idEntidad !== undefined && idEntidad !== null) {
      params = params.set('Id_Entidad', idEntidad.toString());
    }
    return this.http.get<MetricaEntidadDto[]>(`${this.apiUrl}${baseUrl}`, {
      params,
    });
  }

  modificarMetricasConEntidad(
    entidadId: number,
    metricaEntidadDto: MetricaEntidadDto
  ): Observable<MetricaEntidadDto> {
    const url = `${this.apiUrl}/metrica-entidad/actualizar/${entidadId}`;

    return this.http.patch<MetricaEntidadDto>(url, metricaEntidadDto);
  }

  consultarCorreos(idMetrica?: number | null) {
    return this.http.get<CorreoEntidadDTO[]>(
      `${this.apiUrl}/metrica-destinatario?idMetricaEntidad=${idMetrica}`
    );
  }

  agregarCorreo(correo: CorreoEntidadDTO) {
    return this.http.post<RespuestaCorreoDTO>(
      `${this.apiUrl}/metrica-destinatario`,
      correo
    );
  }

  eliminarCorreo(idMetrica?: number | null) {
    return this.http.delete<RespuestaCorreoDTO>(
      `${this.apiUrl}/metrica-destinatario/${idMetrica}`
    );
  }
}
